module.exports = "/_next/static/resources/photo-1-9c5dc09be85b75fef7588fbf69a777fb.webp";